import script from "./AddEditBaseRecipes.vue?vue&type=script&setup=true&lang=js"
export * from "./AddEditBaseRecipes.vue?vue&type=script&setup=true&lang=js"

import "./AddEditBaseRecipes.vue?vue&type=style&index=0&id=4e5e7fb7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e5e7fb7"]])

export default __exports__